import { render, staticRenderFns } from "./TheEconomicCalendar.vue?vue&type=template&id=b26e4ee4&scoped=true"
import script from "./TheEconomicCalendar.vue?vue&type=script&lang=js"
export * from "./TheEconomicCalendar.vue?vue&type=script&lang=js"
import style0 from "./TheEconomicCalendar.vue?vue&type=style&index=0&id=b26e4ee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b26e4ee4",
  null
  
)

export default component.exports